// Components==============
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import './index.module.scss';
// =========================

export default function NewsCardModal({ news }) {
    // // format start date
    const formattedDate = new Date(news?.created_at).toLocaleDateString(
        'nl-NL',
        {
            timeZone: 'Europe/Amsterdam',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }
    );

    return (
        <Modal slug={`/nieuws/nieuws-popup/${news?.id}`} exact>
            <div styleName="wrapper">
                <div styleName="top">
                    <h1>{news?.title}</h1>
                    <p>{formattedDate}</p>
                </div>
                {/* eslint-disable-next-line no-eval */}
                <RichText richText={eval(news?.content)} />
                <br />
                <img src={news?.image} alt="news" />
            </div>
        </Modal>
    );
}
